import React, { useState, useEffect } from "react";
import { Doughnut } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
// import "bootstrap/dist/css/bootstrap.min.css";

ChartJS.register(ArcElement, Tooltip, Legend);

const LoanCalculator = () => {
  const [amount, setAmount] = useState(500000);
  const [rate, setRate] = useState(10.25);
  const [tenure, setTenure] = useState(5);

  const [emi, setEmi] = useState(0);
  const [interest, setInterest] = useState(0);
  const [total, setTotal] = useState(0);

  useEffect(() => {
    calculateEMI();
  }, [amount, rate, tenure]);

  const calculateEMI = () => {
    const principal = amount;
    const monthlyRate = rate / 12 / 100;
    const months = tenure * 12;

    const emiCalc =
      (principal * monthlyRate * Math.pow(1 + monthlyRate, months)) /
      (Math.pow(1 + monthlyRate, months) - 1);

    const totalAmount = emiCalc * months;
    const totalInterest = totalAmount - principal;

    setEmi(Math.round(emiCalc));
    setTotal(Math.round(totalAmount));
    setInterest(Math.round(totalInterest));
  };

  const data = {
    labels: ["Principal", "Interest"],
    datasets: [
      {
        data: [amount, interest],
        backgroundColor: ["#1fa5a9", "#1fb6e4"],
        borderWidth: 1,
      },
    ],
  };

  return (
    <div className="container py-5">
      <h2 className="text-center mb-5 fw-bold">
        Personal Loans EMI Calculator
      </h2>

      <div className="row">

        {/* LEFT SECTION */}
        <div className="col-md-4 bg-light p-4 rounded shadow-sm">

          <label className="fw-semibold">Personal Loans Amount</label>
          <div className="input-group mb-3">
            <input
              type="number"
              className="form-control"
              value={amount}
              onChange={(e) => setAmount(Number(e.target.value))}
            />
            <span className="input-group-text">₹</span>
          </div>
          <input
            type="range"
            className="form-range"
            min="50000"
            max="5000000"
            step="10000"
            value={amount}
            onChange={(e) => setAmount(Number(e.target.value))}
          />

          <label className="fw-semibold mt-4">Interest Rate</label>
          <div className="input-group mb-3">
            <input
              type="number"
              className="form-control"
              value={rate}
              onChange={(e) => setRate(Number(e.target.value))}
            />
            <span className="input-group-text">%</span>
          </div>
          <input
            type="range"
            className="form-range"
            min="5"
            max="20"
            step="0.1"
            value={rate}
            onChange={(e) => setRate(Number(e.target.value))}
          />

          <label className="fw-semibold mt-4">Loan Tenure</label>
          <div className="input-group mb-3">
            <input
              type="number"
              className="form-control"
              value={tenure}
              onChange={(e) => setTenure(Number(e.target.value))}
            />
            <span className="input-group-text">Yrs</span>
          </div>
          <input
            type="range"
            className="form-range"
            min="1"
            max="10"
            value={tenure}
            onChange={(e) => setTenure(Number(e.target.value))}
          />
        </div>

        {/* CENTER SECTION */}
        <div className="col-md-4 text-center bg-light p-4 rounded shadow-sm">
          <div className="mb-4">
            <h5>Principal</h5>
            <h4 className="fw-bold">₹ {amount.toLocaleString()}</h4>
          </div>
          <hr />

          <div className="mb-4">
            <h5>Interest</h5>
            <h4 className="fw-bold">₹ {interest.toLocaleString()}</h4>
          </div>
          <hr />

          <div className="mb-4">
            <h5>Total Payable</h5>
            <h4 className="fw-bold">₹ {total.toLocaleString()}</h4>
          </div>
          <hr />

          <div>
            <h5>Monthly EMI</h5>
            <h4 className="fw-bold text-primary">
              ₹ {emi.toLocaleString()}
            </h4>
          </div>
        </div>

        {/* RIGHT SECTION */}
        <div className="col-md-4 bg-light p-4 rounded shadow-sm">
          <h6 className="text-center mb-3 fw-semibold">
            Payment Breakup
          </h6>
          <Doughnut data={data} />
        </div>

      </div>
    </div>
  );
};

export default LoanCalculator;
